<ng-container *ngFor="let cms of cmsList;let i = index">
  <div id="cmsdirectoryview" class="float-left subBlockContainerBackground" style="width: 960px; display: inline-block;"
    [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
    <child-header [title]="cms?.title" (closeEvent)="removeCmsView(i)"></child-header>
    <!-- <div class="inner-subBlock-wrapper">
    <div class="page-title-wrapper">
    <div class="title blade-title-font">{{cms?.title}}
    </div>
    <i class="material-icons closebutton-pullfloat-right" (click)="removeCmsView(i)">close</i>
  </div>
</div> -->
    <div class="col-md-12" style="height: calc(100vh - 103px);overflow-y: scroll;">
      <div [innerHtml]="cms?.innerHtml | sanitizeHtml" (click)="clickEvent($event)"></div>
    </div>
  </div>
</ng-container>
